import * as React from 'react';
import './ProductShipFromModal.scss';
import { isMobile } from 'src/utils/responsiveHelpers';
import SlideMenu from '../SlideMenu/SlideMenu';
import Modal from '../Modal/Modal';
import DeliverAddressChange from 'src/components/DeliverAddressChange/DeliverAddressChange';
import i18n from 'src/translation/i18n';

interface IProductShipFromModalprops {
  show: boolean;
  onClose: () => void;
  type: 'shipping' | 'pick-up' | '';
  defaultWarehouse: any;
  supplierQuantity: number;
  deliverAddressesList: any[];
  deliveryLocationCode: string;
  buttonVerbiage: string;
  selectedAddresses: object;
  selectedPartState: string;
  selectedPartQty: number;
  handleChangeShipFrom: (address: object) => void;
  
}

interface IProductShipFromModalState {
  isMobile: boolean;
}

class ProductShipFromModal extends React.Component<
  IProductShipFromModalprops,
  IProductShipFromModalState
> {
  constructor(props: any) {
    super(props);

    this.state = {
      isMobile: isMobile()
    };
  }

  private resizeEvent: any;

  private renderDeliverAddressChange = () => {
    return (
      <DeliverAddressChange
        deliverAddresses={this.props.deliverAddressesList}
        defaultWarehouse={this.props.defaultWarehouse}
        handleClose={this.props.onClose}
        supplierQuantity={this.props.supplierQuantity}
        deliveryLocationCode={this.props.deliveryLocationCode}
        showPickUpOnly={false}
        type={this.props.type}
        buttonVerbiage={this.props.buttonVerbiage}
        handleChangeAddress={this.props.handleChangeShipFrom}
        selectedAddresses={this.props.selectedAddresses}
        selectedPartState={this.props.selectedPartState}
        selectedPartQty = {this.props.selectedPartQty}
      />
    );
  };

  public componentWillMount() {
    window.addEventListener('resize', this.handleWindowSizeChange);
  }

  public componentWillUnmount() {
    window.removeEventListener('resize', this.handleWindowSizeChange);
  }

  public componentDidMount() {
    this.forceUpdate();
  }

  public handleWindowSizeChange = () => {
    const isMob = isMobile();
    if (isMob !== this.state.isMobile) {
      this.setState({ isMobile: isMob });
    }
  };

  public render() {
    return this.state.isMobile ? (
      <SlideMenu
        mounted={this.props.show}
        goBackTitle={i18n.t('common.back')}
        level={2 + 30}
        handleCloseMenu={this.props.onClose}
      >
        {this.renderDeliverAddressChange()}
      </SlideMenu>
    ) : (
      this.props.show && (
        <Modal handleCloseModal={this.props.onClose}>
          {this.renderDeliverAddressChange()}
        </Modal>
      )
    );
  }
}

export default ProductShipFromModal;
